export default __webpack_public_path__ + "static/media/Aarthi Jewel Palace.45078925.png";